import Store from '../stores/store';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class B2CStore implements ltFramework.IB2CStore {
	public getInitialData() {
		return (Store.state as ltFramework.IStoreState).b2cModule;
	}

	public initialize(): Promise<void> {
		return Store.dispatch('b2cModule/initialize');
	}

	public login(redirectStartPage?: string): Promise<void> {
		return Store.dispatch('b2cModule/login', redirectStartPage);
	}

	public logout(): Promise<void> {
		return Store.dispatch('b2cModule/logout');
	}

	public listen(callback: (state: ltFramework.IB2CModule) => void): () => void {
		return Store.subscribe((mutation, state) => {
			if (mutation.type.includes('b2cModule/')) {
				callback((state as ltFramework.IStoreState).b2cModule);
			}
		});
	}
}
